export const MIX_PANEL_EVENTS = {
    ENGAGEMENT_SURVEY: {
        ENGAGEMENT_SURVEY_SHOW_QUESTION: 'ENGAGEMENT_SURVEY_SHOW_QUESTION',
        ENGAGEMENT_SURVEY_CLICK_LIKERT: 'ENGAGEMENT_SURVEY_CLICK_LIKERT',
        ENGAGEMENT_SURVEY_CLICK_COMMENT_BOX: 'ENGAGEMENT_SURVEY_CLICK_COMMENT_BOX',
        ENGAGEMENT_SURVEY_COMMENT_CHANGED: 'ENGAGEMENT_SURVEY_COMMENT_CHANGED',
        ENGAGEMENT_SURVEY_CLICK_COMMENT_CLEAR: 'ENGAGEMENT_SURVEY_CLICK_COMMENT_CLEAR',
        ENGAGEMENT_SURVEY_CLICK_BACK: 'ENGAGEMENT_SURVEY_CLICK_BACK',
        ENGAGEMENT_SURVEY_CLICK_NEXT: 'ENGAGEMENT_SURVEY_CLICK_NEXT',
        ENGAGEMENT_SURVEY_SHOW_COMMUNICATION_TIP: 'ENGAGEMENT_SURVEY_SHOW_COMMUNICATION_TIP',
        ENGAGEMENT_SURVEY_CLICK_LOGIN: 'ENGAGEMENT_SURVEY_CLICK_LOGIN'
    }
};
